import { BKJToggleInput } from '@awais4123/fillify-design-library';
import { Flex } from 'components/Flex';
import { useShiftModalDataContext } from 'components/ShiftModal/ShiftModalProvider.data.context';
import { useSendToAgenciesFormContext } from 'components/ShiftModal/src/views/SendToAgenciesView/SendToAgencies.form.context';
import { useFetchAvailableTeamMembersCountDataContext } from 'components/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/OpenShift/FetchAvailableTeamMembersCount.data.context';
import { OpenPay } from 'components/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/ShiftPay/OpenPay';
import {
  InfoSection,
  SendToAgenciesBoldText,
  SendToAgenciesText,
} from 'components/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesView.styled';
import { UseFormBehaviorsEventType } from 'hooks/useFormBehaviors/useFormBehaviors.types';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { formatPlural } from 'utils/formatPlural';
import { formatPossession } from 'utils/formatPossession';
import { getTranslatedResponse } from 'utils/getTranslatedResponse';

function SummaryDetailsInfo() {
  const { t } = useTranslation();
  const { data: fetchOrderData } = useShiftModalDataContext();
  const { values } = useSendToAgenciesFormContext();
  const { data: availableTeamMembersCountData } = useFetchAvailableTeamMembersCountDataContext();
  return (
    <Fragment>
      {!!availableTeamMembersCountData?.requestJanes?.totalCount && (
        <Fragment>
          {values.isDedicated ? (
            <SendToAgenciesText>
              {availableTeamMembersCountData?.requestJanes?.totalCount}&nbsp;
              {t('shift_modal:AVAILABLE_TEAM_MEMBERS_IN')}&nbsp;
              <SendToAgenciesBoldText>
                {`${formatPossession(fetchOrderData?.fetchOrder?.position?.name)} ${t(
                  'shift_modal:TEAM',
                )}`}
              </SendToAgenciesBoldText>
            </SendToAgenciesText>
          ) : (
            <SendToAgenciesText>
              {`${availableTeamMembersCountData?.requestJanes?.totalCount} ${t(
                'shift_modal:AVAILABLE_AGENCY_MEMBERS',
              )}`}
            </SendToAgenciesText>
          )}
        </Fragment>
      )}

      <SendToAgenciesBoldText>
        {`${t('shift_modal:SEND_OUT')} :`}&nbsp;
        {values.specific_time_selection[0] === 'now' ? (
          <SendToAgenciesText>{t('shift_modal:IMMEDIATELY')}</SendToAgenciesText>
        ) : (
          <SendToAgenciesText>
            {`${formatPlural(
              'hour',
              Number.parseInt(values.specific_time_selection[0], 10),
              true,
            )} ${t('shift_modal:BEFORE_SHIFT_STARTS')}`}
          </SendToAgenciesText>
        )}
      </SendToAgenciesBoldText>
    </Fragment>
  );
}

export function OpenShiftComponent() {
  const { t, i18n } = useTranslation();
  const { data } = useShiftModalDataContext();
  const { values, onChange: onChangeForm } = useSendToAgenciesFormContext();
  const { onChange: onChangeFetchAvailableTeamMembersCount } =
    useFetchAvailableTeamMembersCountDataContext();

  const onChange = (e: UseFormBehaviorsEventType) => {
    onChangeForm(e);
    onChangeFetchAvailableTeamMembersCount(e);
  };

  return (
    <Flex flexDirection="column" gap="32px">
      <Flex flexDirection="column" gap="8px">
        <Flex alignItems="center">
          <SendToAgenciesBoldText>{`${getTranslatedResponse(
            data?.fetchOrder?.status.name,
            'status',
            i18n,
            t,
          )}
          ${t('shift_modal:SHIFT')}`}</SendToAgenciesBoldText>
        </Flex>

        <InfoSection flexDirection="column" alignContent="baseline" gap="14px">
          {data?.fetchOrder?.dedicatedPool ? (
            <Flex alignItems="center">
              <SendToAgenciesBoldText>{t('shift_modal:SEND_TO')}: </SendToAgenciesBoldText>&nbsp;
              <SendToAgenciesText>
                {t('shift_modal:ONLY_DEDICATED_TEAM_MEMBERS')}
              </SendToAgenciesText>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <BKJToggleInput
                variant="Switch"
                name="isDedicated"
                checked={values.isDedicated}
                onChange={onChange}
              />
            </Flex>
          ) : null}
          <SummaryDetailsInfo />
        </InfoSection>

        <Flex flexDirection="column" padding="0px 8px 0px 8px">
          <SendToAgenciesText>
            {t('shift_modal:THIS_SHIFT_WILL_BECOME_AVAILABLE_TO')}&nbsp;
            <SendToAgenciesBoldText>
              {formatPlural(data?.fetchOrder?.position?.name)}
            </SendToAgenciesBoldText>
            &nbsp;
            {data?.fetchOrder?.biddable
              ? t('shift_modal:IN_THE_MARKETPLACE_TO_ACCEPT_BIDDING')
              : t('shift_modal:IN_THE_MARKETPLACE_TO_ACCEPT')}
          </SendToAgenciesText>
        </Flex>
      </Flex>
      <OpenPay />
    </Flex>
  );
}
